// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__OqbmK","alert":"SettungsInbox_alert__2VjpP"};